import React, { PureComponent, Fragment } from 'react'
import { Button, Label, Transition, Icon } from 'semantic-ui-react'
import { connect } from 'react-redux'
import CanvasActions from 'Redux/CanvasRedux'
import styles from './BrushSelectorStyles'

const colors = [
  { key: 'teal', hex: '#00b5ad' },
  { key: 'pink', hex: '#e03997' },
  { key: 'yellow', hex: '#fbbd08' },
  { key: 'blue', hex: '#2185d0' }
]

class BrushSelector extends PureComponent {

  constructor(props) {
    super(props)
  
    this.state = {
      visible: false,
      selectedColor: props.strokeColor
    }
  }

  onStrokeColorChange = (color) => () => {
    this.props.canvasSetStrokeColor(color)
  }

  onDrawingStart = () => {
    this.setState({ visible: true })
    this.props.canvasSetActive(true)
  }

  cancelDrawing = () => {
    this.setState({ visible: false })
    this.props.canvasSetActive(false)
  }

  render () {
    const { visible } = this.state
    return (
      <Fragment>
        <Transition visible={visible} animation='slide left' duration={500}>
          <div>
          <div className={styles.colors}>
            {colors.map(color =>
              <Label
                className={styles.label}
                circular
                color={color.key}
                key={color.key}
                onClick={this.onStrokeColorChange(color.hex)}>
                  { color.hex === this.props.selectedColor &&
                    <Icon name='paint brush' />
                  }
              </Label>
            )}
          </div>
          </div>
        </Transition>
        {this.props.isDrawing
          ? <Button
            basic
            primary
            size='mini'
            icon='cancel'
            onClick={this.cancelDrawing} />
          : <Button
            primary
            size='mini'
            icon='paint brush'
            onClick={this.onDrawingStart} />
        }
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  isDrawing: state.canvas.isDrawing,
  selectedColor: state.canvas.strokeColor
})

const mapDispatchToProps = (dispatch) => ({
  canvasSetActive: enabled => dispatch(CanvasActions.canvasSetActive(enabled)),
  canvasSetStrokeColor: color =>
    dispatch(CanvasActions.canvasSetStrokeColor(color)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BrushSelector)



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/CommentBox/BrushSelector.js